import {
  BadgeCheck,
  Calculator,
  CalendarDays,
  Droplet,
  FileText,
  Layers,
  LayoutTemplate,
  PenLine,
  Printer,
  Scale,
  ShieldCheck,
  ShoppingBag,
  Shuffle,
  Tag,
  Thermometer,
} from "lucide-react";
import type { Bonus } from "../types/product";

// Nomi e contenuti dei bonus: modificabili fino alla conferma definitiva.
export const bonuses: Bonus[] = [
  {
    number: 1,
    name: "Il Metodo Base",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/b31c88c3-d842-4f5a-bac7-5e42ec41c90f.jpg",
    benefits: [
      { icon: Layers, lead: "Tutte le tipologie di prodotto:", text: "come sono costruiti burri, scrub, lozioni, sieri e balsami" },
      { icon: Thermometer, lead: "Conservanti e pH spiegati semplici:", text: "quando serve un conservante, quale scegliere e in che dose" },
      { icon: ShieldCheck, lead: "Lavorare in sicurezza:", text: "igiene, strumenti e conservazione per risultati sempre costanti" },
    ],
  },
  {
    number: 2,
    name: "Vendi i tuoi cosmetici",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/7df2f17c-f69b-446c-9dd6-b5307be7bea4.jpg",
    benefits: [
      { icon: Tag, lead: "Prezzi con sicurezza:", text: "il costo reale di ogni lotto, poi quanto chiedere" },
      { icon: FileText, lead: "Modelli di etichetta:", text: "layout pronti, liste INCI e cosa puoi dichiarare per legge" },
      { icon: ShoppingBag, lead: "Vendere nel modo giusto:", text: "da dove iniziare e come presentare le tue prime venti unità" },
    ],
  },
  {
    number: 3,
    name: "Guida alle sostituzioni",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/0287e904-1163-4fc1-a4fb-26f2030b5bbb.jpg",
    benefits: [
      { icon: Shuffle, lead: "Sostituisci per funzione:", text: "cosa fa ogni olio, burro ed emulsionante, per cambiare il simile con il simile" },
      { icon: Scale, lead: "Sempre su 100 g:", text: "cambia un ingrediente senza sballare le percentuali" },
      { icon: Droplet, lead: "Oli, burri e attivi:", text: "alternative sicure per ogni famiglia di ingredienti" },
    ],
  },
  {
    number: 4,
    name: "Quaderno e planner del laboratorio",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/0b31ff7a-6eae-4c9b-a3c2-4213771a1b77.jpg",
    benefits: [
      { icon: Printer, lead: "Stampa e compila:", text: "scheda formula, registro dei lotti e checklist di qualità" },
      { icon: Calculator, lead: "Registro e costi:", text: "quanto ti costa davvero ogni lotto, nero su bianco" },
      { icon: CalendarDays, lead: "Pianifica e monitora:", text: "inventario, scadenze e gestione degli ordini" },
    ],
  },
  {
    number: 5,
    name: "Kit etichette e confezioni",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/def000d6-5417-4996-a24d-095b1fa82ecd.jpg",
    benefits: [
      { icon: BadgeCheck, lead: "Etichette conformi:", text: "numero di lotto, simbolo PAO e le regole da rispettare" },
      { icon: PenLine, lead: "Scrivi il tuo INCI:", text: "trasforma la lista degli ingredienti in un'etichetta corretta" },
      { icon: LayoutTemplate, lead: "Modelli inclusi:", text: "layout di etichette e la confezione giusta per ogni prodotto" },
    ],
  },
];
